import { render, staticRenderFns } from "./nextCourses.vue?vue&type=template&id=e8357278&scoped=true"
import script from "./nextCourses.vue?vue&type=script&lang=js"
export * from "./nextCourses.vue?vue&type=script&lang=js"
import style0 from "./nextCourses.vue?vue&type=style&index=0&id=e8357278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8357278",
  null
  
)

export default component.exports